import { useGetRequest } from 'hooks/utils/useGetRequest';
import { Settlements } from 'interfaces/balances';
import { format } from 'date-fns';

function getPreviousMonth(date = new Date()) {
  const previous = new Date(date.getTime());
  previous.setMonth(date.getMonth() - 1);

  return previous;
}

const useGetSettlements = (startDate?: string, endDate?: string) => {
  const defaultStartDate = `${format(getPreviousMonth(), 'yyyy-MM-dd')}`;
  const defaultEndDate = `${format(new Date(), 'yyyy-MM-dd')}`;
  const path = `v1/balances/settlement?date_from=${startDate || defaultStartDate}&date_to=${endDate || defaultEndDate}`;

  const [{ data, error, loading }] = useGetRequest<Settlements>({
    path,
  });


  return {
    settlements: data?.transactions,
    isLoadingSettlements: loading,
    isError: error,
  };
};

export default useGetSettlements;
